export default "__VITE_ASSET__BJMKBsOv__"